module.exports = __webpack_public_path__ + "fonts/bdf10804b48b83148d9ffb8ed382d209.txt";